export default __webpack_public_path__ + "static/media/live-briefing.7795f551.png";